import styled from 'styled-components';

export const AchievementsList = styled.div`
    display: flex;
    flex-direction: column; 
    margin: 30px;   
`;
